import { render } from "./ViewWorkout.vue?vue&type=template&id=2b690d74"
import script from "./ViewWorkout.vue?vue&type=script&lang=js"
export * from "./ViewWorkout.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__